import { filter, map, each, every, findWhere, findIndex, mapObject } from 'underscore'
import objectAssign from 'object-assign';

import timestamps from '~/services/timestamps'

export default {

    articles: [],
    workshops: [],

    maxInterestGroups: 2, // Should be 1 to hide the clusters

    interestGroup: [],
    ofTheWeek: {},
    featured: [],
    missed: {},
    latest: [],

    usedArticles: [],

    myInterestIDs: [],
    interests: [],

    reset: function(  ) {
        this.interestGroup = []
        this.ofTheWeek = {}
        this.featured = []
        this.missed = {}
        this.latest = []
        this.usedArticles = []
        this.interests = []
    },

    get: function( articles, workshops, myInterests, sessionsAllowed ) {

        if( articles.length < 1 ) return this;

        if( sessionsAllowed ) {
            this.maxInterestGroups = 3;
        }

        this.articles = articles.map(function(article) { return article });
        if( sessionsAllowed ) this.workshops = workshops.map(function(workshop) { return workshop });

        this.reset()

        this.myInterestIDs = myInterests.length > 0 ? myInterests.map(function(interest) { return interest.ID }) : [789, 790]

        this.createFeaturedArticles();
        this.createInterestGroups();
        this.createMostPopularArticle();
        this.createUnreadArticle();
        this.createLatestArticles();
        this.createInterests();

        return this;

    },

    removeArticle: function(article) {
        if( !article ) return;
        let key = findIndex(this.articles, {ID: article.ID})
        if( key > -1 ) this.articles.splice(key, 1)
        this.usedArticles.push( article )
    },

    createInterests: function() {
        let interestIDs = [];
        for (var a = 0; a < this.usedArticles.length; a++) {
            for (var i = 0; i < this.usedArticles[a].interests.length; i++) {
                if( interestIDs.indexOf( this.usedArticles[a].interests[i].ID ) > -1 ) continue
                this.interests.push( this.usedArticles[a].interests[i] )
                interestIDs.push( this.usedArticles[a].interests[i].ID )
            }
        }
    },

    createInterestGroups: function() {

        if( this.workshops.length >= 4 ) this.createWorkshopInterestGroup()
        if( this.workshops.length < 4 )  this.maxInterestGroups = 2

        let groups = this.calculateArticleCount(this.articles, this.myInterestIDs);

        while( Object.keys(groups).length > 0 && this.interestGroup.length < this.maxInterestGroups ) {
            for (var key = 0; key < Object.keys(groups).length; key++) {

                if( this.interestGroup.length >= this.maxInterestGroups ) break;

                let intID = Object.keys(groups)[key],
                    count = groups[intID],
                    articles = this.getArticlesWithInterest(this.articles, intID);

                if(articles.length < 4) continue

                // Get the interest
                let interest = {};
                for (var i = articles[0].interests.length - 1; i >= 0; i--) {
                    if( articles[0].interests[i].ID == intID ) {
                        interest = articles[0].interests[i];
                        break;
                    }
                }

                let groupObj = {
                    interest: interest,
                    posts: []
                }

                for (var key = 0; key < articles.length; key++) {
                    if( groupObj.posts.length >= 4 ) break;
                    groupObj.posts.push( articles[key] )
                    this.removeArticle( articles[key] )
                }
                this.interestGroup.push( groupObj )

            }
            groups = this.calculateArticleCount(this.articles, this.myInterestIDs);
        }

        if( this.interestGroup.length < 1 ) this.createBackupGroup();
        if( this.interestGroup.length < 2 ) this.createBackupGroup();

    },

    createWorkshopInterestGroup: function() {

        let obj = {
            interest: {},
            posts: this.workshops.slice(0, 4)
        }

        this.interestGroup.push(obj)

    },

    createBackupGroup: function() {

        var nextIndex = 5;
        if( this.articles.length - 1 < nextIndex + 4 ) return;

        let newPosts = this.articles.slice(nextIndex, nextIndex + 4)

        this.interestGroup.push({
            interest: {}, 
            posts: newPosts
        })

        for (var p = 0; p < newPosts.length; p++) {
            this.removeArticle( newPosts[p] )
        }

    },

    createMostPopularArticle: function() {

        let winners = {},
            articles = this.articles.slice(0);

        articles.sort(sortByFlares)

        for (var a = articles.length - 1; a >= 0; a--) {
            if( articles[a].length < 1 ) continue;
            if( articles[a].length < Math.max( ...Object.keys(winners)) ) continue;
            let number = filter(articles[a].flares, function(user) { return timestamps.isWithinLastWeek(user.flared) }).length
            if( number < 1 ) continue;
            winners[number] = articles[a];
		}

        this.ofTheWeek = Object.keys(winners).length > 0 && !!winners[ Math.max( ...Object.keys(winners) ) ] 
            ? winners[ Math.max( ...Object.keys(winners) ) ]
            : articles[0];

        this.removeArticle( this.ofTheWeek );

        articles.sort(sortByDateDesc)

    },

    createFeaturedArticles: function() {
        let articles = this.articles.map(function(article) { return article }),
            featured = filter(articles, {featured: true});
        featured.sort(sortByDateDesc)
        this.featured = featured.slice(0,3);
        for (var f = 0; f < this.featured.length; f++) {
            this.removeArticle( this.featured[f] )
        }
    },

    createUnreadArticle: function() {
        let article = findWhere(this.articles, function(article) { return !article.read });
        this.removeArticle(article)
        this.missed = article;
    },

    createLatestArticles: function() {
        this.latest = this.articles.map(function(article) { return article });
        for (var l = 0; l < this.latest.length; l++) {
            this.removeArticle( this.latest[l] )
        }
    },

    getArticlesWithInterest: function(articles, interest_id) {
        return filter(articles, function(article) { 
            let int_ids = map(article.interests, function(interest) { return interest.ID; });
            return int_ids.indexOf( +interest_id ) > -1;
        });
    },

    calculateArticleCount: function(articles, int_ids) {
        let groups = {};
        for (var a = 0; a < articles.length; a++) {
            let article_interest_ids = articles[a].interests.map(function(interest) { return interest.ID; })
            for (var i = 0; i < article_interest_ids.length; i++) {
                let article_int_id = article_interest_ids[i]
                if( int_ids.indexOf( article_int_id ) < 0 ) continue;
                //console.log(article_int_id, int_ids.indexOf( article_int_id ))
                if( !(article_int_id in groups) ) groups[ article_int_id ] = 0;
                groups[ article_int_id ]++;
            }
        }
        let finalObj = {};
        mapObject(groups, function(count, ID) {
            if( count >= 4 ) finalObj[ID] = count
        })
        return finalObj
    }

}

function sortByDateAsc(a,b) {
    if (a.date < b.date) return -1;
    if (a.date > b.date) return 1;
    return 0;
}

function sortByDateDesc(a,b) {
    if (b.date < a.date) return -1;
    if (b.date > a.date) return 1;
    return 0;
}

function sortByFlares(a,b) {
    if (a.flares < b.flares) return -1;
    if (a.flares > b.flares) return 1;
    return 0;
}


// WEBPACK FOOTER //
// ./src/js/services/algorithms/DiscoverFeed.js